import { render, staticRenderFns } from "./AddAtTheInformation.vue?vue&type=template&id=e31274ac&scoped=true&"
import script from "./AddAtTheInformation.vue?vue&type=script&lang=js&"
export * from "./AddAtTheInformation.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tablecss.less?vue&type=style&index=0&id=e31274ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31274ac",
  null
  
)

export default component.exports